<template>
  <div>
    <div class="section text-black pt-lg-3 pt-0">
      <div class="container">
        <h2 class="pt-0 my-1"><b>POLICY PRIVACY</b></h2>
      </div>

      <div class="container mt-4" v-if="isGeodidalab">
        L'applicazione Geodidalab – ideata, realizzata e gestita dall’Università
        di Torino – non richiede alcuna registrazione, né trasmette o memorizza
        dati personali. L'applicazione Geodidalab fa esclusivamente uso di
        cookies tecnici necessari per la navigazione e la fruizione del sito.
        L'applicazione non usa cookies analitici o di profilazione, e non
        contiene alcun messaggio pubblicitario o servizio a pagamento.
      </div>
      <div class="container mt-4" v-else>
        L'applicazione Istituto Mosso – ideata, realizzata e gestita
        dall’Università di Torino – non richiede alcuna registrazione, né
        trasmette o memorizza dati personali. L'applicazione Istituto Mosso fa
        esclusivamente uso di cookies tecnici necessari per la navigazione e la
        fruizione del sito. L'applicazione non usa cookies analitici o di
        profilazione, e non contiene alcun messaggio pubblicitario o servizio a
        pagamento.
      </div>

      <div class="container mt-4">
        <h3 class="pt-0 my-1"><b>COOKIES</b></h3>
      </div>

      <div class="container mt-4">
        <h4>Informativa sull'uso dei cookie</h4>

        Questa informativa sull'utilizzo dei cookie è resa all'utente in
        attuazione del provvedimento del Garante per la protezione dei dati
        personali dell'8 maggio 2014 "Individuazione delle modalità semplificate
        per l'informativa e l'acquisizione del consenso per l'uso dei cookie" e
        nel rispetto dell'art. 13 del Codice privacy (D.Lgs. n. 196/2003). <br/><br/>
        Questo sito utilizza un cookie per garantire il corretto funzionamento
        delle procedure. In questa pagina sono riportate informazioni sull'uso
        dei cookie e di tecnologie similari, su come sono utilizzati e su come
        gestirli.

        <h4>Definizioni</h4>

        I cookie sono brevi frammenti di testo (lettere e/o numeri) che
        permettono al server web di memorizzare sul client (il browser)
        informazioni da riutilizzare nel corso della medesima visita al sito
        (cookie di sessione) o in seguito, anche a distanza di giorni (cookie
        persistenti). I cookie vengono memorizzati, in base alle preferenze
        dell'utente, dal singolo browser sullo specifico dispositivo utilizzato
        (computer, tablet, smartphone). <br/><br/>Tecnologie similari, come, ad esempio,
        web beacon, GIF trasparenti e tutte le forme di storage locale
        introdotte con HTML5, sono utilizzabili per raccogliere informazioni sul
        comportamento dell'utente e sull'utilizzo dei servizi.<br/><br/> Nel seguito di
        questo documento faremo riferimento ai cookie e a tutte le tecnologie
        similari utilizzando semplicemente il termine "cookie".

        <h4>Tipologie di cookie</h4>

        In base alle caratteristiche e all'utilizzo dei cookie possiamo
        distinguere diverse categorie:
        <ul class="mx-5">
          <li>
            <b>Cookie tecnici.</b> Si tratta di cookie strettamente necessari,
            indispensabili per il corretto funzionamento dei siti e sono
            utilizzati per gestire il login e l'accesso alle funzioni riservate.
            <br/>La durata dei cookie è limitata alla sessione di lavoro. La loro
            disattivazione compromette l'utilizzo dei servizi accessibili da
            login. La parte pubblica resta normalmente utilizzabile. Questo sito
            utilizza esclusivamente un cookie di questo tipo.
          </li>
          <li>
            <b>Cookie di profilazione.</b> Si tratta di cookie permanenti
            utilizzati per identificare (in modo anonimo e non) le preferenze
            dell'utente e migliorare la sua esperienza di navigazione. Questo
            sito non utilizza cookie di questo tipo.
          </li>
        </ul>

        <h4>Durata dei cookie</h4>

        Alcuni cookie utilizzati da questo sito terminano la propria validità al
        momento della chiusura della scheda del browser, altri invece dopo un anno.

        <h4>Contenuto incorporato da altri siti web</h4>

        Gli articoli su questo sito possono includere contenuti incorporati (ad
        esempio video, immagini, articoli, ecc.). I contenuti incorporati da
        altri siti web si comportano esattamente allo stesso modo come se il
        visitatore avesse visitato l’altro sito web. <br/><br/>Questi siti web possono
        raccogliere dati su di te, usare cookie, integrare ulteriori
        tracciamenti di terze parti e monitorare l’interazione con quel
        contenuto incorporato, incluso il tracciamento della tua interazione con
        il contenuto incorporato se hai un account e hai effettuato l’accesso a
        quel sito web.

        <h4>Gestione dei cookie</h4>

        In generale l'utente può comunque decidere se accettare o meno i cookie
        utilizzando le impostazioni del proprio browser.

        <ul class="mx-5">
          <li>
            <a
              href="https://support.google.com/chrome/answer/95647?hl=it"
              target="_blank"
              >Chrome
            </a>
          </li>
          <li>
            <a
              href="https://support.mozilla.org/it/kb/Gestione%20dei%20cookie"
              target="_blank"
              >Firefox</a
            >
          </li>
          <li>
            <a
              href="https://support.microsoft.com/it-it/help/17442/windows-internet-explorer-delete-manage-cookies"
              target="_blank"
              >Internet Explorer</a
            >
          </li>
          <li>
            <a
              href="https://help.opera.com/Windows/10.20/it/cookies.html"
              target="_blank"
              >Opera</a
            >
          </li>
          <li>
            <a
              href="https://support.apple.com/it-it/guide/safari/sfri11471/mac"
              target="_blank"
              >Safari</a
            >
          </li>
        </ul>

        L'impostazione può essere definita in modo specifico per i diversi siti
        e applicazioni web.
      </div>
    </div>
  </div>
</template>
<script>
import strumento from "../components/customComponents/strumento";
import $ from "jquery";
import store from "../store";
import { config } from "../utils/config";
import ScrollTopArrow from "../components/customComponents/ScrollTopArrow";
import { Checkbox, Collapse, CollapseItem, Radio, Modal } from "../components";
import { Button } from "element-ui";

const Common = require("@/Common.vue").default;

export default {
  name: "strumenti",
  bodyClass: "strumenti-esperimenti-page",
  components: {},
  data() {
    return {
      windowWidth: 0,
      allLoaded: false,
      isGeodidalab: true,
      allAmbitiScientifici: [],
      selectAllAbitoScientifico: false,
      allAmbitiScientificiLoaded: false,
    };
  },

  beforeMount() {
    this.$store.commit("removePOIAndActivities");

    this.isGeodidalab = config.isGeodidalab;

    this.windowWidth = $(window).width();

    $(window).resize(() => {
      this.windowWidth = $(window).width();
    });

    var self = this;

    Common.getElemsByClass(this, config.omekaIDs.omekaIDstrumenti, (res) => {
      store.state.strumenti = res.body;
      self.allLoaded = true;
    });

    Common.getElemsByClass(
      this,
      config.omekaIDs.omekaIDambitoScientifico,
      (res) => {
        store.state.ambitiScientificiOmeka = res.body;
        store.commit("setAllAmbitiScientificiStrumenti");
        self.allAmbitiScientificiLoaded = true;
      }
    );
  },

  methods: {
    selectAllAbitoScientificoFunctions() {
      Array.prototype.forEach.call(
        this.$store.state.ambitiScientificiStrumenti,
        (ambito) => {
          this.$set(ambito, "ambitoScientificoSelected", true);
        }
      );

      this.checkAbitoScientifico();
    },
    deselectAllAbitoScientificoFunctions() {
      Array.prototype.forEach.call(
        this.$store.state.ambitiScientificiStrumenti,
        (ambito) => {
          this.$set(ambito, "ambitoScientificoSelected", false);
        }
      );

      this.checkAbitoScientifico();
    },
    getAmbitoScientificoCollapseTitle() {
      var count = 0;

      Array.prototype.forEach.call(
        this.$store.state.ambitiScientificiStrumenti,
        (ambito) => {
          ambito.ambitoScientificoSelected ? count++ : null;
        }
      );

      var title = "Ambito scientifico";

      if (count === 1) {
        title += " (" + count + " selezionato)";
      } else if (count > 1) {
        title += " (" + count + " selezionati)";
      }

      return title;
    },
    checkAbitoScientifico() {
      var notSelectedPresent = false;

      Array.prototype.forEach.call(
        this.$store.state.ambitiScientificiStrumenti,
        (ambito) => {
          if (!ambito.ambitoScientificoSelected) {
            notSelectedPresent = true;
          }
        }
      );

      if (notSelectedPresent) {
        this.selectAllAbitoScientifico = false;
      } else {
        this.selectAllAbitoScientifico = true;
      }
    },
    checkIfStrumentoHasCorrectAmbito(strumento) {
      if (!this.isGeodidalab) {
        var ambito = strumento["geo:appartiene_a_ambito"][0]["display_title"];

        if (this.selectedAmbiti.length === 0) {
          return true;
        } else {
          if (this.selectedAmbiti.includes(ambito)) {
            return true;
          } else {
            return false;
          }
        }
      } else {
        return true;
      }
    },
  },

  computed: {
    isLarge() {
      return this.windowWidth >= 768;
    },
    selectedAmbiti() {
      var mappedAmbiti = this.$store.state.ambitiScientificiStrumenti
        .filter((ambito) => ambito.ambitoScientificoSelected)
        .map((ambito) => ambito.ambitoScientificoName);

      var allAmbiti = this.$store.state.ambitiScientificiOmeka.map(
        (ambito) => ambito["o:title"]
      );

      if (mappedAmbiti.length === 0) {
        return allAmbiti; //this.allInterests;
      } else {
        return mappedAmbiti;
      }
    },
  },

  watch: {},
};
</script>
<style>
</style>